import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=3395d5c3"
import script from "./UploadModal.vue?vue&type=script&lang=js"
export * from "./UploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3395d5c3')) {
      api.createRecord('3395d5c3', component.options)
    } else {
      api.reload('3395d5c3', component.options)
    }
    module.hot.accept("./UploadModal.vue?vue&type=template&id=3395d5c3", function () {
      api.rerender('3395d5c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/UploadModal.vue"
export default component.exports